/**
 * @generated SignedSource<<5eda90d5644a0daada80806bf43d9a6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePasswordResetInput = {
  usernameOrEmail: string;
};
export type SendPasswordResetPageMutation$variables = {
  input: CreatePasswordResetInput;
};
export type SendPasswordResetPageMutation$data = {
  readonly createPasswordReset: {
    readonly canResendAt: string;
  };
};
export type SendPasswordResetPageMutation = {
  response: SendPasswordResetPageMutation$data;
  variables: SendPasswordResetPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PasswordReset",
    "kind": "LinkedField",
    "name": "createPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canResendAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendPasswordResetPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendPasswordResetPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d238cb7e4f979bf27ba82b6db654c780",
    "id": null,
    "metadata": {},
    "name": "SendPasswordResetPageMutation",
    "operationKind": "mutation",
    "text": "mutation SendPasswordResetPageMutation(\n  $input: CreatePasswordResetInput!\n) {\n  createPasswordReset(input: $input) {\n    canResendAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "71efe93edabbbf362d1b495d3984dbca";

export default node;
